/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The UpdateUserRequest model module.
* @module model/UpdateUserRequest
* @version 2020-12-7
*/
export default class UpdateUserRequest {
    /**
    * Constructs a new <code>UpdateUserRequest</code>.
    * ユーザー更新リクエスト
    * @alias module:model/UpdateUserRequest
    * @class
    * @param groupId {Number} グループID
    * @param roleId {Number} ロールID
    * @param name {String} ユーザー名
    * @param loginId {String} ログインID
    */

    constructor(groupId, roleId, name, loginId) {
        
        
        this['groupId'] = groupId;
        this['roleId'] = roleId;
        this['name'] = name;
        this['loginId'] = loginId;
        
    }

    /**
    * Constructs a <code>UpdateUserRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/UpdateUserRequest} obj Optional instance to populate.
    * @return {module:model/UpdateUserRequest} The populated <code>UpdateUserRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateUserRequest();
                        
            
            if (data.hasOwnProperty('groupId')) {
                obj['groupId'] = ApiClient.convertToType(data['groupId'], 'Number');
            }
            if (data.hasOwnProperty('deliveryGroupId')) {
                obj['deliveryGroupId'] = ApiClient.convertToType(data['deliveryGroupId'], 'Number');
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ApiClient.convertToType(data['roleId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('loginId')) {
                obj['loginId'] = ApiClient.convertToType(data['loginId'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
        }
        return obj;
    }

    /**
    * グループID
    * @member {Number} groupId
    */
    'groupId' = undefined;
    /**
    * 配送グループID
    * @member {Number} deliveryGroupId
    */
    'deliveryGroupId' = undefined;
    /**
    * ロールID
    * @member {Number} roleId
    */
    'roleId' = undefined;
    /**
    * ユーザー名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * ログインID
    * @member {String} loginId
    */
    'loginId' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;




}
